export enum FileStatus {
  Complete = 'complete',
  Error = 'error',
  InProgress = 'inProgress',
}
